/* eslint-disable no-use-before-define */
import { reactive, ref } from "@vue/composition-api";

export default function useEmialForm() {
  const initFormState = () => ({
    mailName: undefined,
    mailDescription: "",
    mailHeader: "",
    mailContent: "",
    recipientAddress: [{ name: "", email: "" }],
    approverPhone: [{ name: "", phone: "" }],
  });

  const validateEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const re = /^1[3-9][0-9]{9}$/;
    return re.test(phone);
  };

  // 自定义校验收件人邮件
  const validateRecipientAddress = (rule, value, callback) => {
    const emailFormatValid = value.every((item) => validateEmail(item.email));
    const nameValid = value.every((item) => item.name);
    if (!nameValid) {
      callback(new Error("请填写收件人名称！"));
    } else if (!emailFormatValid) {
      callback(new Error("请填写正确的邮箱格式！"));
    } else {
      callback();
    }
  };

  // 自定义校验审批人手机号
  const validateApproverPhone = (rule, value, callback) => {
    const phoneFormatValid = value.every((item) => validatePhone(item.phone));
    const nameValid = value.every((item) => item.name);
    if (!nameValid) {
      callback(new Error("请填写审批人名称！"));
    } else if (!phoneFormatValid) {
      callback(new Error("请填写正确的手机号！"));
    } else {
      callback();
    }
  };

  const formVariables = reactive({
    formState: ref(initFormState()),
    rules: {
      mailName: [{ required: true, message: "请输入邮件名称", trigger: "change" }],
      mailDescription: [{ required: true, message: "请输入邮件描述", trigger: "blur" }],
      mailHeader: [{ required: true, message: "请输入邮件标题", trigger: "blur" }],
      mailContent: [{ required: true, message: "请输入邮件内容", trigger: "blur" }],
      recipientAddress: [{ required: true, validator: validateRecipientAddress, trigger: "change" }],
      approverPhone: [{ required: true, validator: validateApproverPhone, trigger: "change" }],
    },
  });

  // 重置表单
  const restFormState = () => {
    formVariables.formState = initFormState();
  };

  return {
    formVariables,
    restFormState,
  };
}
